// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"534":"Expired","601":"new-features"}[chunkId] || chunkId) + "." + {"215":"7ffd53ed","534":"8468becf","601":"8a9d474d","926":"fa1f555f"}[chunkId] + ".css";
};